import type { UpgradePreview } from "@/react/types/Paywalls/Checkout/UpgradePreview";

import { uniqueUpgradeCoupons } from "./uniqueUpgradeCoupons";

/** Only show discounts certified for the current selection's invoice. */
export const upgradeCouponBadge = (
  preview: UpgradePreview | undefined,
  selectedPriceId: string,
  isRefreshing: boolean,
) => {
  if (
    !preview ||
    isRefreshing ||
    preview.selected_paywall_price_id !== Number(selectedPriceId)
  ) {
    return undefined;
  }

  const discounts = preview.coupon.effective_discounts.filter(
    discount =>
      (discount.application_invoice === "today" &&
        (discount.today_amount?.amount ?? 0) > 0) ||
      (discount.application_invoice === "first_paid_renewal" &&
        (discount.first_paid_renewal_amount?.amount ?? 0) > 0),
  );
  if (!discounts.length) return undefined;

  return {
    label:
      preview.labels.percent_off_today?.label ??
      uniqueUpgradeCoupons(discounts)
        .map(discount => discount.chip_label)
        .join(", "),
  };
};
